<template>
  <v-container class="redeem-welcome-gift">
    <v-row>
      <v-col>
        <h2>{{ $t('admin_redeem_welcome_gift.title') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <v-text-field outlined
                      v-model="hkiaraceCardNo"
                      :label="$t('admin_redeem_welcome_gift.hkiarace_card_no')"
                      :placeholder="$t('admin_redeem_welcome_gift.hkiarace_card_no')"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" block
               x-large
               @click="startQrCodeReader">
          <v-icon>fas fa-camera</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn block
               color="primary"
               x-large
               :disabled="!hkiaraceCardNo"
               @click="search">
          SEARCH
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="qrCodeReaderModalShown">
      <v-card>
        <v-card-title class="headline">
          Scan QRCode
        </v-card-title>
        <v-card-text>
          <v-row v-if="qrCodeReaderModalShown">
            <v-col>
              <QrcodeStream :camera="qrCodeReaderSuspended? 'off' : 'auto'"
                            @decode="onDecode"
                            class="qr-code-reader">
                <div class="qr-code-reader-overlay" v-if="qrCodeReaderSuspended">
                  <label>PROCESSING...</label>
                </div>
              </QrcodeStream>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="accountModalShown" max-width="900px">
      <v-card v-if="hkiaraceAccount">
        <v-card-title></v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('admin_user.serial_no')"
                              :value="hkiaraceCardNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('register.surname_zh')"
                              :value="hkiaraceAccount.surname_zh"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field readonly
                              :label="$t('register.given_name_zh')"
                              :value="hkiaraceAccount.given_name_zh"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('register.surname_en')"
                              :value="hkiaraceAccount.surname_en"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field readonly
                              :label="$t('register.given_name_en')"
                              :value="hkiaraceAccount.given_name_en"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('register.company')"
                              :value="hkiaraceAccount.company.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('admin_user.welcome_gift_redeemed')"
                              :value="userWelcomeGiftRedeemedLabel"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn x-large
                 @click="accountModalShown = false">
            CANCEL
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 x-large
                 :disabled="hkiaraceAccount.welcome_gift_redeemed"
                 @click="redeem">
            REDEEM
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {computed, ref} from '@vue/composition-api'
import {QrcodeStream} from 'vue-qrcode-reader'
import {DateTime} from "luxon";

export default {
  name: 'HkiaraceRedeemWelcomeGift',
  components: {QrcodeStream},
  setup(props, {root}) {
    const hkiaraceCardNo = ref(null);

    const qrCodeReaderModalShown = ref(false);
    const qrCodeReaderSuspended = ref(false);
    const startQrCodeReader = function () {
      qrCodeReaderModalShown.value = true;
      qrCodeReaderSuspended.value = false;
    }
    const onDecode = function (data) {
      qrCodeReaderSuspended.value = true;

      let cardNo = parseInt(data);

      if (!isNaN(cardNo)) {
        hkiaraceCardNo.value = cardNo;
        search();
      } else {
        root.$callAPI('hkiarace/admin/info/', {
          token: data,
        }, (response) => {
          if (response.body.account) {
            hkiaraceAccount.value = response.body.account;
            accountModalShown.value = true;
            hkiaraceCardNo.value = hkiaraceAccount.value.serial_no;
          } else {
            root.$showAlertMessage('Invalid QR Code');
          }
        });
      }
      qrCodeReaderSuspended.value = false;
      qrCodeReaderModalShown.value = false;
    };

    const search = function () {
      root.$callAPI('hkiarace/admin/user/', {
        hkiarace_id: hkiaraceCardNo.value,
      }, (response) => {
        if (response.body.user) {
          hkiaraceAccount.value = response.body.user;
          accountModalShown.value = true;
          hkiaraceCardNo.value = hkiaraceAccount.value.id;
        }
      });
    };

    const accountModalShown = ref(false);
    const hkiaraceAccount = ref(null);
    const userWelcomeGiftRedeemedLabel = computed(() => {
      if (!hkiaraceAccount.value) {
        return '';
      }

      return hkiaraceAccount.value.welcome_gift_redeemed ? hkiaraceAccount.value.welcome_gift_redeemed_at ? DateTime.fromISO(hkiaraceAccount.value.welcome_gift_redeemed_at).toFormat('yyyy-MM-dd') : 'Redeemed at Event' : 'N/A';
    });
    const redeem = function () {
      if (confirm('Redeem Welcome Gift?')) {
        root.$callAPI('hkiarace/admin/user/redeem_gift/', {
          id: hkiaraceCardNo.value,
        }, function (response) {
          accountModalShown.value = false;
          hkiaraceAccount.value = null;
          this.$showAlertMessage('Successfully Redeemed');
        })
      }
    }

    return {
      hkiaraceCardNo,

      qrCodeReaderModalShown,
      qrCodeReaderSuspended,
      startQrCodeReader,
      onDecode,
      search,
      accountModalShown,
      hkiaraceAccount,
      userWelcomeGiftRedeemedLabel,
      redeem,
    }
  }
}
</script>

<style lang="less">
.redeem-welcome-gift {

}
</style>
